module.exports = __webpack_public_path__ + "static/media/logo-small.bad03621.png";